export const flag = "VRa";
export default {flag};